import React, { useContext, useState } from 'react';
import { ZdsDivider, ZdsIcon, ZdsInputSearch, ZdsItem, ZdsPopout } from '@zig-design-system/ui-components-react';
import { RootContext } from '../../Context/RootContext';
import ApiService from '../services/ApiService';
import Translation from '../../Shared/components/Translation';
import NoResults from '../../Shared/components/Search/NoResults';
const Search = () => {
    const [actions, setActions] = useState([]);
    const [hits, setHits] = useState([]);
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const rootContext = useContext(RootContext);
    const apiService = new ApiService(rootContext);
    const handleSearch = (event) => {
        if (event.detail && event.detail !== search) {
            apiService.search(event.detail, rootContext.pluginContext.startNodeUid).then((hits) => {
                setHits(hits.filter((hit) => !hit.isAction));
                setActions(hits.filter((hit) => hit.isAction));
                setSearch(event.detail);
                setOpen(true);
            });
        }
    };
    const clearSearch = () => {
        setTimeout(() => {
            setHits([]);
            setActions([]);
            setOpen(false);
        }, 200);
    };
    const KbHits = ({ title, items, spaceAbove = false, }) => {
        return (React.createElement(React.Fragment, null,
            React.createElement("h4", { className: 'zds-margin-bottom-3 zds-margin-bottom-sm-color zds-headline-md' +
                    (spaceAbove ? ' zds-margin-top-12' : '') },
                React.createElement(Translation, { item: title })),
            React.createElement(ZdsDivider, { className: "zds-margin-0" }), items === null || items === void 0 ? void 0 :
            items.map((item, index) => {
                var _a, _b;
                const [iconLibrary, iconName] = (_b = (_a = item.icon) === null || _a === void 0 ? void 0 : _a.split('_')) !== null && _b !== void 0 ? _b : [];
                let target = null;
                let link = '#/node/' + item.uid;
                let linkIcon = 'arrow_forward_ios';
                if (item.externalLink) {
                    target = '_blank';
                    link = item.externalLink;
                    linkIcon = 'open_in_new';
                }
                return (React.createElement(React.Fragment, { key: index },
                    React.createElement(ZdsItem, { link: link, linkTarget: target, onZdsClick: clearSearch },
                        React.createElement("div", { slot: "primary-text", className: "zds-bold" }, item.title),
                        React.createElement("div", { slot: "content-end" },
                            React.createElement(ZdsIcon, { name: linkIcon, size: "sm" })),
                        iconLibrary && iconName && (React.createElement("div", { slot: "content-start", className: "search-list-icon zds-flex-col zds-items-center" },
                            React.createElement(ZdsIcon, { className: "zds-color-accent-02", library: iconLibrary, name: iconName })))),
                    React.createElement(ZdsDivider, { className: "zds-margin-0" })));
            })));
    };
    const renderResults = () => {
        return (React.createElement(React.Fragment, null,
            actions.length > 0 && React.createElement(KbHits, { items: actions, title: "zig_sitepackage.arrangeImmediately" }),
            hits.length > 0 && React.createElement(KbHits, { items: hits, title: "zig_sitepackage.other", spaceAbove: !!actions.length }),
            hits.length === 0 && actions.length === 0 && React.createElement(NoResults, null)));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ZdsInputSearch, { "aria-label": "Zoeken", id: "kb-input-search", onZdsBlur: clearSearch, onZdsSearch: handleSearch, className: 'zds-margin-bottom-8' }),
        React.createElement(ZdsPopout, { id: "search-result-popout", target: "#kb-input-search", open: open, fallbackPlacements: "bottom" }, renderResults())));
};
export default Search;
